import {grey} from '@mui/material/colors'

// A leaf module: the build rejects circular chunks.
export const SECONDARY_MAIN = grey[600]
